__turbopack_context__.v({
  "logo": "MadeWithPrezly-module-scss-module__qHTgCG__logo",
  "text": "MadeWithPrezly-module-scss-module__qHTgCG__text",
  "wrapper": "MadeWithPrezly-module-scss-module__qHTgCG__wrapper",
});
